import * as React from "react";
import classnames from "classnames";
import { motion } from "motion/react";
import { useOnClickOutside } from "@grandvisionhq/lib-utils-react";
import { ButtonDropdownButton } from "../components/ButtonDropdownButton/ButtonDropdown/components/ButtonDropdownButton/ButtonDropdownButton.js";
import { ButtonDropdownContent } from "../components/ButtonDropdownContent/ButtonDropdown/components/ButtonDropdownContent/ButtonDropdownContent.js";
import { ButtonDropdownGridCell } from "../components/ButtonDropdownGridCell/ButtonDropdown/components/ButtonDropdownGridCell/ButtonDropdownGridCell.js";
import { ButtonDropdownGridRow } from "../components/ButtonDropdownGridRow/ButtonDropdown/components/ButtonDropdownGridRow/ButtonDropdownGridRow.js";
import { ButtonDropdownInteractiveWrapper } from "../components/ButtonDropdownInteractiveWrapper/ButtonDropdown/components/ButtonDropdownInteractiveWrapper/ButtonDropdownInteractiveWrapper.js";
import { ButtonDropdownEmptyOption } from "../components/ButtonDropdownOption/ButtonDropdown/components/ButtonDropdownOption/ButtonDropdownEmptyOption.js";
import { ButtonDropdownOption } from "../components/ButtonDropdownOption/ButtonDropdown/components/ButtonDropdownOption/ButtonDropdownOption.js";
import { ButtonDropdownSelect } from "../components/ButtonDropdownSelect/ButtonDropdown/components/ButtonDropdownSelect/ButtonDropdownSelect.js";
import { ButtonDropdownProvider } from "../context/ButtonDropdown/context/ButtonDropdownContext.js";
/* empty css                    */
const ButtonDropdown = ({
  "aria-label": ariaLabel,
  "data-t": dataT,
  className,
  isDisabled,
  isInvalid,
  offset,
  placement,
  isRequired,
  children,
  onChange,
  value,
  cols,
  itemSizes,
  orientation,
  loop,
  focusItemOnHover
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const dropdownRef = React.useRef(null);
  useOnClickOutside(dropdownRef, () => {
    setIsOpen(false);
  });
  return /* @__PURE__ */ React.createElement(
    ButtonDropdownProvider,
    {
      "aria-label": ariaLabel,
      isDisabled,
      isInvalid,
      isOpen,
      offset,
      placement,
      isRequired,
      setIsOpen,
      onChange,
      value,
      cols,
      orientation,
      itemSizes,
      loop,
      focusItemOnHover
    },
    /* @__PURE__ */ React.createElement(
      motion.div,
      {
        ref: dropdownRef,
        animate: isOpen ? "button-dropdown--is-open" : "button-dropdown--is-closed",
        className: classnames("button-dropdown", className),
        "data-t": dataT
      },
      children
    )
  );
};
ButtonDropdown.Button = ButtonDropdownButton;
ButtonDropdown.Content = ButtonDropdownContent;
ButtonDropdown.EmptyOption = ButtonDropdownEmptyOption;
ButtonDropdown.GridCell = ButtonDropdownGridCell;
ButtonDropdown.GridRow = ButtonDropdownGridRow;
ButtonDropdown.InteractiveWrapper = ButtonDropdownInteractiveWrapper;
ButtonDropdown.Option = ButtonDropdownOption;
ButtonDropdown.Select = ButtonDropdownSelect;
export {
  ButtonDropdown,
  ButtonDropdown as default
};
//# sourceMappingURL=ButtonDropdown.js.map
